/**
 * How tall the owner wants the Command Center conversation.
 */
const KEY = 'brunel.command.chat.height';
export const CHAT_MIN_PX = 200;
/** Room kept for the composer, horizontal grip and minimum surrounding chrome. */
export const CHAT_COMPOSER_RESERVE_PX = 168;
interface StringStore { getItem(key: string): string | null; setItem(key: string, value: string): void; }

/** The owner may drag almost to the bottom; only the input strip is reserved. */
export function clampChatHeight(px: number, viewportPx: number): number {
  const tallest = Math.max(CHAT_MIN_PX, viewportPx - CHAT_COMPOSER_RESERVE_PX);
  return Math.round(Math.min(tallest, Math.max(CHAT_MIN_PX, px)));
}
export function recallChatHeight(store: StringStore | null): number | null {
  if (store === null) return null;
  let raw: string | null = null;
  try { raw = store.getItem(KEY); } catch { return null; }
  if (raw === null) return null;
  const px = Number(raw);
  return Number.isFinite(px) && px > 0 ? px : null;
}
export function rememberChatHeight(store: StringStore | null, px: number): void {
  if (store === null) return;
  try { store.setItem(KEY, String(Math.round(px))); } catch { /* browser storage may be disabled */ }
}
